import { useCallback, useEffect,useState } from "react";

const useAudioDuration = () => {
    const [audioDuration , setAudioDuration] = useState(0);
    const [audioSecondsLeft , setAudioSecondsLeft] = useState(0);

    const handleAudioPlaying = useCallback((obj) => {
        const secondsLeft = Math.ceil((obj.duration - obj.position) / 1000);
        setAudioSecondsLeft(secondsLeft);
        if (audioDuration === 0) {
      setAudioDuration(Math.ceil(obj.duration / 1000));
    }
    },[audioDuration])

    const resetAudioDuration = useCallback(() => {
    setAudioDuration(0);
    setAudioSecondsLeft(0);
  }, []);

  return {
    audioDuration,
    audioSecondsLeft,
    handleAudioPlaying,
    resetAudioDuration
  };
}

export default useAudioDuration;